import React from 'react';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';

import LocalOfferIconMessage from 'bento-ordering/base/components/LocalOfferIconMessage';
import { usePromotionProgressCartUpdateMesssage } from 'bento-ordering/promotions/hooks/usePromotionProgressCartUpdateMesssage';
import { getSectionNavLighterColor } from 'styles/helpers/getThemeStyles';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '0 16px',
  borderBottom: `1px solid ${getSectionNavLighterColor(theme)}`
}));

function ToastPromotionProgress() {
  const promotionUpdateMessage = usePromotionProgressCartUpdateMesssage();
  if (!promotionUpdateMessage) {
    return null;
  }

  return (
    <StyledBox>
      <LocalOfferIconMessage message={promotionUpdateMessage} />
    </StyledBox>
  );
}

export default ToastPromotionProgress;
